import React from 'react';
import aigcLogo from '../assets/images/AiGC.png';


function AlbertaFooter() {
  return (
    <footer className="footerSec" id="footerId">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="aigcBox">
              <div className="aigcLogoWrap">
                <img src={aigcLogo} alt="Alberta iGaming Corporation" className="aigcLogoImage" />
              </div>
              <p className="aigcDescription">
                Alberta iGaming Corporation (AiGC) works with the Government of Alberta and the Alberta Gaming, Liquor and Cannabis Commission (AGLC) to support Alberta&rsquo;s regulated online gaming market, helping provide a safe, secure, and responsible gaming environment for players.
              </p>
            </div>
            <div className="footerLogosRow">
              
              <div className="footerCopyBlock">
                <p className="f-16 w-500 text-center f-white br-4 mustSection">Must be 18+. and physically present in Alberta. If gambling is affecting your mental health or well-being, 211 Alberta is here to help. Call or text <a href="tel:211" className="f-white">211</a> or visit <a href="https://ab.211.ca" className="f-white" target="_blank" rel="noopener noreferrer">ab.211.ca</a>.</p>
                
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default AlbertaFooter;
